import { createEffect, createEvent, createStore, sample } from 'effector';
import { pending } from 'patronum';
import * as Zod from 'zod';
import i18n from '@shared/config/i18n';
import { createForm } from '@unicorn/effector-form';
import { $openedId } from '../../detail-sdui-opened-id/model';
import { incidentsRelated } from '../api';

export const setShowEnterMessageToApplicant = createEvent<boolean>();
export const $showEnterMessageToApplicant = createStore(false);

export const fxSendMessageToApplicant = createEffect<
  { text: string; id: number | string },
  void,
  Error
>().use(incidentsRelated.sendMessageToApplicant);

export const $sendMessageToApplicantPending = pending({
  effects: [fxSendMessageToApplicant],
});

export const resetMessageHasSent = createEvent();
export const $messageHasSent = createStore(null)
  .on(fxSendMessageToApplicant.doneData, (_, result) => result)
  .reset([
    sample({ clock: $sendMessageToApplicantPending, filter: (status) => !!status }),
    fxSendMessageToApplicant.fail,
    resetMessageHasSent,
  ]);

export const messageForm = createForm<{ text: string }>({
  initialValues: {
    text: '',
  },
  editable: true,
  validationSchema: Zod.object({
    text: Zod.string().min(1, { message: i18n.t('thisIsRequiredField') as string }),
  }),
  resetOn: [$messageHasSent, $openedId],
});
